<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-fill-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 17.75H7.47917L14.4792 10.75L13.25 9.52081L6.25 16.5208V17.75ZM18.1875 9.54165L14.4583 5.81248L15.4792 4.79165C15.8264 4.44442 16.2396 4.27081 16.7188 4.27081C17.1979 4.27081 17.6111 4.44442 17.9583 4.79165L19.2083 6.04165C19.5417 6.37498 19.7083 6.78817 19.7083 7.28123C19.7083 7.77429 19.5417 8.18748 19.2083 8.52081L18.1875 9.54165ZM16.9583 10.7708L8.22917 19.5H4.5V15.7708L13.2292 7.04165L16.9583 10.7708ZM13.875 10.1458L13.25 9.52081L14.4792 10.75L13.875 10.1458Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
